import * as React from 'react';
import './TotalTable.scss';

import LocaleFormating from 'src/translation/localeFormating';

export interface ITotalTableProps {
  total: number;
  current: number;
  pastDue1: number;
  pastDue31: number;
  pastDue61: number;
  t?: any;
}

let t: any;

const numberFormat = (value: number) => {
  return value
    ? LocaleFormating.formatCurrency(parseFloat(value.toString()))
    : LocaleFormating.formatCurrency(0.0);
};

const renderHeader = (
  header: string,
  extra: string,
  columnWidth: '1' | '2'
) => {
  return (
    <p
      className={`rp-ms-total-table--header-title rp-ms-table-total-column-widht-${columnWidth}`}
    >
      <span>{header}</span>
      {extra && <span>{extra}</span>}
    </p>
  );
};

const renderTotals = (value: string, columnWidth: '1' | '2') => {
  return (
    <p
      className={`rp-ms-total-table--info-data rp-ms-table-total-column-widht-${columnWidth}`}
    >
      {value}
    </p>
  );
};

const TotalTableMobile: React.SFC<any> = props => {
  const { total, current, pastDue1, pastDue31, pastDue61 } = props;
  return (
    <div className="rp-total-table-mobile-container">
      <div className="rp-total-table-mobile-info-container">
        <div className="rp-total-table-info">
          <p className="rp-total-table-info-title">
            {t('accountMonthlyStatements.tableTotal')}
          </p>
          {total && <p className="rp-total-table-info-data">{total}</p>}
        </div>
        <div className="rp-total-table-info">
          <p className="rp-total-table-info-title">
            Current {t('accountMonthlyStatements.current')}
          </p>
          {current && <p className="rp-total-table-info-data">{current}</p>}
        </div>
        <div className="rp-total-table-info">
          <p className="rp-total-table-info-title">
            {t('common.pastDue')} 1-30
          </p>
          {pastDue1 && <p className="rp-total-table-info-data">{pastDue1}</p>}
        </div>
        <div className="rp-total-table-info">
          <p className="rp-total-table-info-title">
            {t('common.pastDue')} 31-60
          </p>
          {pastDue31 && <p className="rp-total-table-info-data">{pastDue31}</p>}
        </div>
        <div className="rp-total-table-info">
          <p className="rp-total-table-info-title">{t('common.pastDue')} 61+</p>
          {pastDue61 && <p className="rp-total-table-info-data">{pastDue61}</p>}
        </div>
      </div>
    </div>
  );
};

const TotalTable: React.SFC<ITotalTableProps> = props => {
  const { total, current, pastDue1, pastDue31, pastDue61 } = props;
  t = props.t;
  const headers: JSX.Element[] = [];
  const amounts: JSX.Element[] = [];
  const values = [
    { header: '', value: '', columnWidth: '10' },
    { header: '', value: '', columnWidth: '10' },
    { header: '', value: '', columnWidth: '10' },
    { header: '', value: '', columnWidth: '10' },
    {
      header: `${t('accountMonthlyStatements.tableTotal')}`,
      value: numberFormat(total),
      columnWidth: '12'
    },
    {
      header: `${t('accountMonthlyStatements.current')}`,
      value: numberFormat(current),
      columnWidth: '12'
    },
    {
      header: `${t('common.pastDue')}`,
      extra: '1-30',
      value: numberFormat(pastDue1),
      columnWidth: '12'
    },
    {
      header: `${t('common.pastDue')}`,
      extra: '31-60',
      value: numberFormat(pastDue31),
      columnWidth: '12'
    },
    {
      header: `${t('common.pastDue')}`,
      extra: '61+',
      value: numberFormat(pastDue61),
      columnWidth: '12'
    }
  ];
  values.map(
    (item: {
      header: string;
      extra: string;
      value: string;
      columnWidth: '1' | '2';
    }) => {
      headers.push(renderHeader(item.header, item.extra, item.columnWidth));
      amounts.push(renderTotals(item.value, item.columnWidth));
    }
  );
  return (
    <div className="rp-ms-total-table--container">
      <div className="rp-ms-total-table--container-desktop">
        <div className="rp-ms-total-table-header-container">{headers}</div>
        <div className="rp-ms-total-table-info-container">{amounts}</div>
      </div>
      <div className="rp-ms-total-table--container-mobile">
        <TotalTableMobile
          total={numberFormat(total)}
          current={numberFormat(current)}
          pastDue1={numberFormat(pastDue1)}
          pastDue31={numberFormat(pastDue31)}
          pastDue61={numberFormat(pastDue61)}
        />
      </div>
    </div>
  );
};

export default TotalTable;
